import React from 'react';
import logo from '../../images/smart-alarm-logo.svg';
import { LoginBtn } from '../components/ui';

const LoginForm = () => {
    return (
        <form className='login__sign-in'>
            <div className='se-logo--login'>
                <span className='ecostruxure-logo'></span>
                <img src={logo} className="logo sa-logo" alt="logo" />
            </div>
            
            <h3 className='mt-0'>{`Version ${import.meta.env.VITE_APP_VERSION}`}</h3>
            
            <p className='mt-2'><strong>SmartAlarm</strong> is a versatile and powerful solution for managing alarms and events across multiple customer sites. Its cloud-based architecture, site-based monitoring, and customizable reporting capabilities make it an ideal choice for organizations seeking to optimize their alarm management processes.</p>
            
            <LoginBtn />
        
        </form>
    );
}

export default LoginForm